import { combineReducers } from "redux";
import { externalRegistryData, integrationData, validatePasswordData } from "./reducer";

export default combineReducers({
  externalRegistryData,
  integrationData,
  validatePasswordData
});
